import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import isArray from 'lodash/isArray';
import { makeStyles } from '@material-ui/core/styles';
import TitledBlock from '../TitledBlock';
import ListText from '../ListText';
import { useTranslation } from '../../src/i18n';
import { TP } from '../../constants/consts';
import OriginalName from '../OriginalName';

const useStyles = makeStyles(() => ({
  titleCell: {
    maxWidth: '200px',
  },
}));

const listedCardLabels = {
  performedOn: {
    title: `${TP}.FN_PERFORMED_ON`,
    property: 'periode',
    fieldToDisplay: '',
  },
  work: {
    title: `${TP}.m_MUSICALWORK`,
    property: 'work',
  },
  composer: {
    title: `${TP}.m_COMPOSER`,
    property: 'work.composer',
  },
  companies: {
    title: `${TP}.m_COMPANY`,
    property: 'companies',
  },
  venues: {
    title: `${TP}.m_VENUE`,
    property: 'venues',
  },
  city: {
    title: `${TP}.COMPETITIONS_TOWN`,
    property: 'city',
  },
  country: {
    title: `${TP}.m_COUNTRY`,
    property: 'country',
  },
};

const ProductionListedCardHeaders = ({ production, labels }) => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <>
      {Object.keys(labels).map(key => {
        const item = labels[key];
        if (isArray(get(production, item.property)) && get(production, item.property).length === 0) {
          return null;
        }
        return (
          get(production, item.property) && (
            <TitledBlock key={t(item.title)} title={t(item.title)} className={classes.titleCell}>
              {key === 'work' ? (
                <OriginalName
                  name={get(production, 'work.name')}
                  originalName={get(production, 'work.original_name')}
                />
              ) : (
                <ListText list={get(production, item.property)} />
              )}
            </TitledBlock>
          )
        );
      })}
    </>
  );
};

ProductionListedCardHeaders.propTypes = {
  production: PropTypes.object,
  labels: PropTypes.object,
};

ProductionListedCardHeaders.defaultProps = {
  labels: listedCardLabels,
};

export default ProductionListedCardHeaders;
